/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { trackPage } from './trackPage';

/**
 * A tracking hook for pageview event. The 'page' parameter is virtual url path for tracking only, e.g. in '/valuation/15116812/' page only sends '/valuation/' to datalayer.
 * @param {string} page - the page url for tracking
 * @param {object} extraTaxonomy - custom taxonomy object for pageview event
 * @param {object} extraEcommerce - custom ecommerce object for pageview event
 */
export const usePageTracking = (
    page?: string,
    extraTaxonomy: Record<string, unknown> = {},
    extraEcommerce: Record<string, unknown> | null = null
) => {
    useEffect(() => {
        if (page) {
            trackPage(page, extraTaxonomy, extraEcommerce);
        }
    }, []);
};
